import { SessionGuard } from "./SessionGuard";

/** Student portal pages. The rules live in SessionGuard. */
export const StudentRouter = ({ children }) => (
  <SessionGuard area="student">{children}</SessionGuard>
);
